import React from 'react';
import MaterialTable, { TableProps as MaterialTableProps } from '@mui/material/Table';
import styled from 'styled-components';

const StyledTable = styled(MaterialTable)``;
export interface TableProps extends MaterialTableProps {}

const Table: React.FunctionComponent<TableProps> = ({ children, ...props }) => {
    return <StyledTable {...props}>{children}</StyledTable>;
};

export default Table;
